import React from 'react'
import BillingsContainer from './BillingsContainer'

const Billings = (props) => (
  <BillingsContainer {...props} />
)

export default Billings



// WEBPACK FOOTER //
// src/routes/Billings/index.js